import styled, { css } from 'styled-components';
export default styled.div.withConfig({
  displayName: "Badgestyles",
  componentId: "cncv13-0"
})(["text-align:center;letter-spacing:normal;background-image:none;border-radius:3px;box-sizing:border-box;line-height:normal;padding:0.375rem 0.5rem 0.375rem 0.5rem;font-size:", ";", " ", " ", " ", ""], function (props) {
  return props.theme.font.size.caption;
}, function (props) {
  return css(["font-family:", ";font-weight:", ";"], props.theme.font.family.brand, props.theme.font.weight.bold);
}, function (props) {
  return css(["color:", ";background-color:", ";"], props.color, props.backgroundColor);
}, function (props) {
  return props.flyout && css(["position:relative;border-radius:0;&::before{top:1.625rem;left:0;border:4px solid ", ";border-bottom-color:transparent;border-left-color:transparent;content:'';position:absolute;width:0;height:0;}"], props.flyoutColor);
}, function (props) {
  return props.counter && css(["display:inline-flex;justify-content:center;align-items:center;border-radius:50px;padding:0.25rem 0.5rem;border:2px solid;border-color:", ";"], props.borderColor);
});